import { render, staticRenderFns } from "./actMaleRecords.vue?vue&type=template&id=249128ce&scoped=true"
import script from "./actMaleRecords.vue?vue&type=script&lang=js"
export * from "./actMaleRecords.vue?vue&type=script&lang=js"
import style0 from "./actMaleRecords.vue?vue&type=style&index=0&id=249128ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249128ce",
  null
  
)

export default component.exports